import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Work from '../components/Work';
import Life from '../components/Life';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import useReveal from '../hooks/useReveal';

export default function HomePage() {
  useReveal();

  useEffect(() => {
    // Smooth anchor behaviour on first load if hash present
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 120);
    }
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Experience />
        <Work />
        <About />
        <Life />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
